function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';
export function Clock({
  width = 20,
  height = 20,
  ...props
}) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: width,
    height: height,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 1.493c-4.687 0-8.5 3.796-8.5 8.462s3.813 8.462 8.5 8.462c4.687 0 8.5-3.796 8.5-8.462S14.687 1.493 10 1.493zm0 18.418c-5.514 0-10-4.466-10-9.956C0 4.466 4.486 0 10 0s10 4.466 10 9.955c0 5.49-4.486 9.956-10 9.956z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.431 13.633a.758.758 0 01-.384-.105l-3.77-2.239a.75.75 0 01-.366-.642V5.821c0-.412.336-.747.75-.747.415 0 .75.335.75.747v4.402l3.405 2.021a.747.747 0 01-.385 1.389z",
    fill: "#000"
  }));
}
//# sourceMappingURL=Clock.js.map